export default {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  RESET_PWD: 'RESET_PWD',
};



// WEBPACK FOOTER //
// ./src/constants/authFormsStates.js